var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11494 12.5034C2.56075 13.1192 1.61232 13.1691 0.996553 12.6149C0.380788 12.0608 0.33087 11.1123 0.885059 10.4966L3.11494 12.5034ZM11 1.5L9.88506 0.496552C10.1648 0.185712 10.5616 0.00577068 10.9798 0.000135422C11.3979 -0.00549889 11.7995 0.163686 12.0875 0.466875L11 1.5ZM21.5875 10.4669C22.1581 11.0675 22.1337 12.0169 21.5331 12.5875C20.9325 13.1581 19.9831 13.1337 19.4125 12.5331L21.5875 10.4669ZM0.885059 10.4966L9.88506 0.496552L12.1149 2.50345L3.11494 12.5034L0.885059 10.4966ZM12.0875 0.466875L21.5875 10.4669L19.4125 12.5331L9.9125 2.53312L12.0875 0.466875Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.5f4a38100da0883599919a1eb8629792.svg";
export { ForwardRef as ReactComponent };